import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrUpdateTermTypePayload } from 'api/actions/hr-update-term-type/hr-update-term-type-payload';
import { HrUpdateTermTypePathParameters } from 'api/actions/hr-update-term-type/hr-update-term-type-path-parameters';
import { HrUpdateTermTypeResponse } from 'api/actions/hr-update-term-type/hr-update-term-type-response';

type HrUpdateTermTypeQueryParameters = Record<string, any>;

/**
 * The path of the HrUpdateTermType action.
 */
export const hrUpdateTermTypeActionPath = new SweetPath<keyof HrUpdateTermTypePathParameters>(
  '/api/hr/term-types/{termTypeId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrUpdateTermType actions.
 */
export default function createHrUpdateTermTypeAction(axios: AxiosInstance) {
  return function hrUpdateTermTypeAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrUpdateTermTypePathParameters;
    query?: HrUpdateTermTypeQueryParameters;
    payload: HrUpdateTermTypePayload;
  }) {
    const path = hrUpdateTermTypeActionPath.insert(parameters);

    return axios.request<HrUpdateTermTypeResponse, HrUpdateTermTypeResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
